import { RESET_RESPONSE_POLICY } from "../ErrorResponse/types";
import {
  GET_POLICY_DETAILS_TRACK,
  SET_UPLOAD_FLOW,
  STATUS_OF_APPLICATION,
  TRANSACTION_ENTRY,
  SET_BULLET_POINTS,
  SET_CODE_STATUS,
  SET_APP_SOURCE,
  SET_STATUS_FLAG_PDF_DETAILS,
  RESET_ACCEPT_OFFER_PDF_DETAILS,
  SET_BEARER_TYPE
} from "./types";

const initialOfferAcceptanceObj = {
  bulletPoints : [],
  code :  "",
  status : {
      isLoading: false,
      loadingMsg: [],
      isDeductible: false,
      deductibleMsg: [],
      isCounterOffer: false,
      counterOfferMsg: [],
      isCopay: false,
      copayMsg: [],
      isSpecialCondition: false,
      specialConditionMsg: []
  }
}

const initialState = {
  localPolicyNumber: null,
  localApplicationNumber: null,
  normalFlowForUpload: true,
  transactionId: null,
  appSource: "APPTRACKER",
  bearerObj: null,
  offerAcceptanceDetails: {
   ...initialOfferAcceptanceObj
  }
};

const renewalReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_POLICY_DETAILS_TRACK:
      return { ...state, ...payload }
    case STATUS_OF_APPLICATION:
      return { ...state, ...payload }
    case SET_UPLOAD_FLOW: {
      return { ...state, normalFlowForUpload: payload }
    }
    case SET_APP_SOURCE:
      return { 
        ...state,
        appSource:  payload?.source,
        }
    case SET_BEARER_TYPE:
      return { 
        ...state,
        bearerObj:  payload,
        }
    case TRANSACTION_ENTRY:
      return { ...state, ...payload };
    case SET_BULLET_POINTS:
      return { ...state, offerAcceptanceDetails: {
        ...state?.offerAcceptanceDetails,
        bulletPoints: payload
      }};
    case SET_CODE_STATUS:
      return { ...state, offerAcceptanceDetails: {
        ...state?.offerAcceptanceDetails,
        code: payload
      }};
    case SET_STATUS_FLAG_PDF_DETAILS:
      return { ...state, offerAcceptanceDetails: {
        ...state?.offerAcceptanceDetails,
        status: {...payload},
      }};
    case RESET_ACCEPT_OFFER_PDF_DETAILS:
      return { ...state, offerAcceptanceDetails: { ...initialOfferAcceptanceObj }};
    case RESET_RESPONSE_POLICY:
      return { ...initialState }
    default:
      return state;
  }
};

export default renewalReducer;
